if (!customElements.get('hero-ltb-slideshow')) {
  class HeroLtbSlideshow extends SlideshowComponent {
    constructor() {
      super();
      this.transition = this.dataset.transition || 'slide';
      this.pauseOnHover = this.dataset.pauseOnHover !== 'false';

      if (this.transition === 'fade' && Array.isArray(this.sliderItemsToShow) === false && this.sliderItemsToShow) {
        this.sliderItemsToShow = Array.from(this.sliderItemsToShow);
      }

      if (this.transition === 'fade' && this.sliderItemsToShow && this.sliderItemsToShow.length > 0) {
        this.currentPage = 1;
        this.fadeUpdate();
      }
    }

    fadeUpdate() {
      const total = this.sliderItemsToShow.length;
      this.sliderItemsToShow.forEach((slide, i) => {
        const isActive = i === this.currentPage - 1;
        slide.setAttribute('aria-hidden', String(!isActive));
        if (isActive) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }
        slide.querySelectorAll('a, button').forEach((el) => {
          if (isActive) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });

      const buttons = this.querySelectorAll('.slider-counter__link');
      buttons.forEach((b, i) => {
        if (i === this.currentPage - 1) {
          b.classList.add('slider-counter__link--active');
          b.setAttribute('aria-current', 'true');
        } else {
          b.classList.remove('slider-counter__link--active');
          b.removeAttribute('aria-current');
        }
      });

      if (this.currentPageElement) this.currentPageElement.textContent = this.currentPage;
      if (this.pageTotalElement) this.pageTotalElement.textContent = total;

      if (this.prevButton) this.prevButton.removeAttribute('disabled');
      if (this.nextButton) this.nextButton.removeAttribute('disabled');
    }

    onButtonClick(event) {
      if (this.transition !== 'fade') return super.onButtonClick(event);
      event.preventDefault();
      const total = this.sliderItemsToShow.length;
      const dir = event.currentTarget.name === 'next' ? 1 : -1;
      this.currentPage = ((this.currentPage - 1 + dir) % total + total) % total + 1;
      this.fadeUpdate();
    }

    linkToSlide(event) {
      if (this.transition !== 'fade') return super.linkToSlide(event);
      event.preventDefault();
      const idx = this.sliderControlLinksArray.indexOf(event.currentTarget);
      if (idx < 0) return;
      this.currentPage = idx + 1;
      this.fadeUpdate();
    }

    autoRotateSlides() {
      if (this.transition !== 'fade') return super.autoRotateSlides();
      const total = this.sliderItemsToShow.length;
      this.currentPage = (this.currentPage % total) + 1;
      this.fadeUpdate();
    }

    setAutoPlay() {
      if (this.pauseOnHover) return super.setAutoPlay();

      this.autoplaySpeed = this.slider.dataset.speed * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reducedMotion.matches) return;

      const btn = this.querySelector('.slideshow__autoplay');
      if (btn) {
        this.sliderAutoplayButton = btn;
        btn.addEventListener('click', this.autoPlayToggle.bind(this));
        this.autoplayButtonIsSetToPlay = true;
      }
      this.play();
    }
  }

  customElements.define('hero-ltb-slideshow', HeroLtbSlideshow);
}
